"use strict";
var t, a;
function R() {
  if (a) return t;
  a = 1;
  var n = String.prototype.replace, F = /%20/g, r = {
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
  };
  return t = {
    default: r.RFC3986,
    formatters: {
      RFC1738: function(e) {
        return n.call(e, F, "+");
      },
      RFC3986: function(e) {
        return String(e);
      }
    },
    RFC1738: r.RFC1738,
    RFC3986: r.RFC3986
  }, t;
}
export {
  R as __require
};
//# sourceMappingURL=index.es47.js.map
